import React from "react";
import { PaintRoller, Replace, Wrench } from "lucide-react";
import { BOYA_TIPLERI, ONARIM_SEVIYELERI } from "../../lib/parcaIslemUtils";
import { PANEL_INPUT, PANEL_SELECT } from "../../lib/panelFormStyles";

function ToggleBtn({ active, onClick, children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`px-2.5 py-1.5 rounded-md text-[11px] border transition ${
                active
                    ? "bg-[#D4AF37]/15 border-[#D4AF37]/40 text-[#F3E5AB]"
                    : "border-white/10 text-slate-400 hover:border-white/20 hover:text-slate-200"
            }`}
        >
            {children}
        </button>
    );
}

/** Değişim | Onarım | Boya — onarım + boya aynı parçada seçilebilir. */
export default function ParcaIslemEditor({ value, onChange, compact = false }) {
    const v = value || {};
    const set = (patch) => onChange({ ...v, ...patch });

    const pickDegisim = () => {
        set({ islem_degisim: true, islem_onarim: false, islem_boya: false });
    };

    const toggleOnarim = () => {
        if (v.islem_degisim) {
            set({ islem_degisim: false, islem_onarim: true, islem_boya: false });
            return;
        }
        const next = !v.islem_onarim;
        if (!next && !v.islem_boya) {
            set({ islem_onarim: true });
            return;
        }
        set({ islem_onarim: next, islem_degisim: false });
    };

    const toggleBoya = () => {
        if (v.islem_degisim) {
            set({ islem_degisim: false, islem_onarim: false, islem_boya: true });
            return;
        }
        const next = !v.islem_boya;
        if (!next && !v.islem_onarim) {
            set({ islem_boya: true });
            return;
        }
        set({ islem_boya: next, islem_degisim: false });
    };

    return (
        <div className={compact ? "space-y-2" : "space-y-3"}>
            <div className="flex flex-wrap gap-1.5">
                <ToggleBtn active={v.islem_degisim} onClick={pickDegisim}>
                    <span className="inline-flex items-center gap-1">
                        <Replace className="h-3 w-3" />
                        Değişim
                    </span>
                </ToggleBtn>
                <ToggleBtn active={v.islem_onarim && !v.islem_degisim} onClick={toggleOnarim}>
                    <span className="inline-flex items-center gap-1">
                        <Wrench className="h-3 w-3" />
                        Onarım
                    </span>
                </ToggleBtn>
                <ToggleBtn active={v.islem_boya && !v.islem_degisim} onClick={toggleBoya}>
                    <span className="inline-flex items-center gap-1">
                        <PaintRoller className="h-3 w-3" />
                        Boya
                    </span>
                </ToggleBtn>
            </div>
            {v.islem_onarim && v.islem_boya && !v.islem_degisim && (
                <p className="text-[10px] text-emerald-300/80">
                    Onarım + boya birlikte — hasar katsayıları toplanır.
                </p>
            )}
            <div className={`grid gap-2 ${compact ? "grid-cols-2" : "grid-cols-2 sm:grid-cols-4"}`}>
                {v.islem_onarim && !v.islem_degisim && (
                    <select
                        value={v.onarim_seviyesi || "ORTA"}
                        onChange={(e) => set({ onarim_seviyesi: e.target.value })}
                        className={PANEL_SELECT}
                    >
                        {ONARIM_SEVIYELERI.map((o) => (
                            <option key={o.value} value={o.value}>
                                Onarım: {o.label}
                            </option>
                        ))}
                    </select>
                )}
                {v.islem_boya && !v.islem_degisim && (
                    <select
                        value={v.boya_tipi || "TAM"}
                        onChange={(e) => set({ boya_tipi: e.target.value })}
                        className={PANEL_SELECT}
                    >
                        {BOYA_TIPLERI.map((o) => (
                            <option key={o.value} value={o.value}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                )}
                <input
                    type="number"
                    min="1"
                    value={v.adet ?? 1}
                    onChange={(e) => set({ adet: e.target.value })}
                    placeholder="Adet"
                    className={PANEL_INPUT}
                />
            </div>
        </div>
    );
}
